export default "__VITE_ASSET__DU7SJn8p__"